var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.249512 5.19053H12.8997V6.80904H0.249512V5.19053Z","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.07249 0L13.5003 5.42777C13.8163 5.7438 13.8163 6.2562 13.5003 6.57223L8.07249 12L6.92803 10.8555L11.7836 6L6.92803 1.14446L8.07249 0Z","fill":"white","key":1})]);
}

RightArrow.defaultProps = {"width":"14","height":"12","viewBox":"0 0 14 12","fill":"none"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
